import {DebounceSelectOptionProps} from "../../../components/UI/AntCustom/DebounceSelect";
import {BookingApiPlaneListRequest, PageModel} from "../../../proto/generated/api_entities_pb";
import {API} from "../../../API/API";
import {IPlane, IPlaneShort} from "../../../store/reducers/fleetReducer/fleetReducerTypes";
import {PlaneStatus} from "../../../utils/constans/statuses/planeStatuses";
import {InitialPage} from "../../constans/pagination/pagination";
import {PageModelLimits} from "../../constans/pagination/pageModelLimits";

export async function fetchOwnPlanes(search: string): Promise<DebounceSelectOptionProps[]> {
  const req = new BookingApiPlaneListRequest()
    .setQuery(search ?? "")
    .setPagemodel(
      new PageModel()
        .setPage(InitialPage)
        .setLimit(1000) // Большой лимит, чтобы получить все самолёты для фильтрации
    );

  const planeList = await API.getPlaneList(req);

  // Фильтруем только одобренные самолёты (PlaneStatus.APPROVED = 3)
  return planeList.getPlanesList()
    .filter(plane => plane.getPlanestatusid() === PlaneStatus.APPROVED)
    .map(plane => {
      return {
        key: plane.getPlaneid(),
        label: plane.getRegistrationnumber(),
        value: plane.getPlaneid(),
      }
    })
}

export const getInitialOwnPlaneForSelect = (plane: IPlaneShort | IPlane): DebounceSelectOptionProps => {
  return {
    key: plane.id,
    value: plane.id,
    label: plane.registrationNumber,
  }
}
